import { render } from "./AppHeader.vue?vue&type=template&id=bfd926f8"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=bfd926f8&lang=scss"
script.render = render

export default script